<template>
    <header class="header" :class="{'header__move' : scrollHeight > 5}">
        <div class="header__container container" :class="{'container-move' : scrollHeight > 5}">
            <a href="#main" class="header__icon" @click="anchor($event, 'main')">
                <svg width="105" height="30" viewBox="0 0 105 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M69.0641 9.18866V5.74911H58.1854V13.8124H55.4508L56.8879 17.2519H58.1854V25.3152H69.0641V21.8757H61.6705V17.2519H65.5812V13.8124H61.6705V9.18866H69.0641Z" 
                    :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                    <path d="M100.716 5.74911V13.8124H95.0617V5.74911H91.5789V13.8124H88.8444L90.2791 17.2519H91.5789V25.3152H95.0617V17.2519H100.716V25.3152H104.199V5.74911H100.716Z" 
                    :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                    <path d="M55.4531 5.74689V9.19095H50.9954V25.3152H47.5126V9.19095H43.5812V5.74689H55.4531Z" 
                    :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                    <path d="M79.714 21.8734C76.1625 21.8734 73.2883 19.035 73.2883 15.5345C73.2883 12.0339 76.1625 9.18869 79.714 9.18869C81.7368 9.18869 83.5355 10.113 84.7117 11.5525H89.1968C87.6247 7.9096 83.9725 5.35593 79.714 5.35593C74.0206 5.35593 69.4096 9.91186 69.4096 15.5322C69.4096 21.1525 74.0229 25.7017 79.714 25.7017C83.9725 25.7017 87.6293 23.1503 89.1968 19.5051H84.7117C83.5355 20.9469 81.7368 21.8689 79.714 21.8689V21.8734Z" 
                    :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                    <path d="M37.5767 18.1085C38.9997 18.1085 40.1533 16.9692 40.1533 15.5638C40.1533 14.1585 38.9997 13.0192 37.5767 13.0192C36.1536 13.0192 35 14.1585 35 15.5638C35 16.9692 36.1536 18.1085 37.5767 18.1085Z" 
                    :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                    <path d="M32.2082 30L21.0229 28.391L15.7689 15.8034V28.391H5.254V15.8034H0V3.21356H10.5103V15.8034L15.7689 3.21356L27.6201 0L21.0229 15.8034H26.2792L32.2082 30Z" 
                    :fill="scrollHeight < 5 ? '#0E2AEF' : '#00DBFF'"/>
                </svg>
            </a>
            <span class="header__line"></span>
            <ul class="header__menu">
                <li class="header__item">
                    <a href="#program" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'program')">
                        {{ $t('program') }} 
                    </a> 
                </li>
                <li class="header__item">
                    <a href="#registration" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'registration')">
                        {{ $t('registry') }}
                    </a> 
                </li>
                <li v-if="false" class="header__item">
                    <a href="#head8" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'head8')">
                        {{ $t('program') }} 
                    </a> 
                </li>
                <li class="header__item">
                    <a href="#nomination" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'nomination')">
                        номинация
                    </a> 
                </li>
                <li class="header__item">
                    <a href="#cio" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'cio')">
                        cio
                    </a> 
                </li>
                <!-- href="#head4" -->
                    <!-- @click="anchor($event)"> -->
                <!-- <li class="header__item">
                    
                    <a href="#head4" class="header__link" :class="{'descr-move' : scrollHeight > 5}">
                        {{ $t('program') }}  
                    </a> 
                </li> -->
                <li class="header__item">
                    <a href="#partners" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'partners')">
                        {{ $t('headers.item1') }}  
                    </a> 
                </li>
                <li v-if="true" class="header__item">
                    <a href="#speakers" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'speakers')">
                        {{ $t('headers.item2') }}  
                    </a> 
                </li>
                <li class="header__item">
                    <a href="#footer" class="header__link" :class="{'descr-move' : scrollHeight > 5}" @click="anchor($event, 'footer')">
                        {{ $t('contacts') }}  
                    </a> 
                </li>
            </ul>
            <span class="header__line"></span>
            <ul class="header__socials">
                <li class="header__socials-item">
                    <a href="https://www.facebook.com/groups/KazakhstanGrowthForum/" target="_blank" class="header__link">
                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.4167 13.0758C26.4167 6.13 20.6343 0.5 13.5 0.5C6.36574 0.5 0.583374 6.13 0.583374 13.0758C0.583374 19.3542 5.30571 24.5567 11.4816 25.5V16.7117H8.20248V13.075H11.4816V10.305C11.4816 7.15333 13.4096 5.41167 16.3607 5.41167C17.7729 5.41167 19.2523 5.6575 19.2523 5.6575V8.7525H17.6222C16.0179 8.7525 15.5185 9.7225 15.5185 10.7175V13.0758H19.1007L18.5281 16.7108H15.5185V25.5C21.6944 24.5567 26.4167 19.3542 26.4167 13.0758Z" 
                                :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"
                            />
                        </svg>
                    </a>
                </li>
                <li class="header__socials-item">
                    <a href="https://www.youtube.com/@KazakhstanGrowthForum" target="_blank" class="header__link">
                        <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5646 0.768384C24.6756 1.05721 25.5544 1.90767 25.8528 2.98276C26.4 4.9404 26.4166 9.00009 26.4166 9.00009C26.4166 9.00009 26.4166 13.0758 25.8694 15.0174C25.5709 16.0925 24.6922 16.943 23.5812 17.2318C21.5749 17.7613 13.4999 17.7613 13.4999 17.7613C13.4999 17.7613 5.42493 17.7613 3.41862 17.2318C2.30768 16.943 1.42889 16.0925 1.13043 15.0174C0.583252 13.0598 0.583252 9.00009 0.583252 9.00009C0.583252 9.00009 0.583252 4.9404 1.11385 2.99881C1.41231 1.92371 2.2911 1.07327 3.40204 0.784436C5.40835 0.254903 13.4833 0.238861 13.4833 0.238861C13.4833 0.238861 21.5583 0.238861 23.5646 0.768384ZM17.612 9.0001L10.9133 12.7549V5.24528L17.612 9.0001Z" 
                                :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                        </svg>
                    </a>
                </li>
               
                <li class="header__socials-item">
                    <a href="https://www.instagram.com/ktech_summit/" target="_blank" class="header__link">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.7074 0.817501C8.94739 0.762749 9.34265 0.75 12.5 0.75C15.6581 0.75 16.0526 0.7635 17.2919 0.817501C18.5295 0.87225 19.3759 1.0635 20.1151 1.34025C20.8905 1.62289 21.593 2.06567 22.1736 2.63775C22.7649 3.19974 23.2224 3.8798 23.5143 4.6305C23.8019 5.346 23.9987 6.16425 24.0553 7.362C24.1118 8.562 24.125 8.9445 24.125 12C24.125 15.0555 24.1118 15.438 24.0553 16.638C23.9987 17.8358 23.8019 18.654 23.515 19.3695C23.223 20.1199 22.7655 20.7997 22.1743 21.3615C21.593 21.9345 20.8901 22.377 20.1151 22.659C19.3759 22.9372 18.5303 23.1277 17.2926 23.1825C16.0526 23.2373 15.6573 23.25 12.5 23.25C9.34265 23.25 8.94739 23.2373 7.7074 23.1825C6.46973 23.1277 5.62415 22.9372 4.88489 22.6598C4.1095 22.3771 3.4071 21.9343 2.82642 21.3623C2.23438 20.7998 1.7771 20.1195 1.48572 19.3695C1.19812 18.654 1.00134 17.8358 0.944702 16.638C0.888184 15.438 0.875 15.0563 0.875 12C0.875 8.94375 0.888916 8.562 0.944702 7.36275C1.00134 6.165 1.19897 5.346 1.48499 4.6305C1.77698 3.88012 2.2345 3.20035 2.82568 2.6385C3.40698 2.0655 4.10986 1.623 4.88489 1.341C5.62415 1.06275 6.46973 0.87225 7.7074 0.817501ZM17.198 2.8425C15.972 2.7885 15.6039 2.77725 12.5 2.77725C9.39612 2.77725 9.02795 2.7885 7.802 2.8425C6.66895 2.89275 6.05359 3.07575 5.64355 3.23025C5.13855 3.41023 4.68176 3.69753 4.30664 4.071C3.90063 4.46475 3.64795 4.83975 3.43787 5.36475C3.27747 5.7615 3.08923 6.357 3.03723 7.4535C2.98145 8.64 2.96985 8.99625 2.96985 12C2.96985 15.0037 2.98145 15.36 3.03723 16.5465C3.08923 17.643 3.27832 18.2385 3.43787 18.6353C3.62402 19.1239 3.9209 19.566 4.30664 19.929C4.68176 20.3024 5.13867 20.5897 5.64355 20.7698C6.05359 20.925 6.66895 21.1072 7.802 21.1575C9.02795 21.2115 9.39539 21.2227 12.5 21.2227C15.6046 21.2227 15.972 21.2115 17.198 21.1575C18.3311 21.1072 18.9464 20.9242 19.3564 20.7698C19.8615 20.5898 20.3182 20.3025 20.6934 19.929C21.0791 19.566 21.376 19.1239 21.5621 18.6353C21.7225 18.2385 21.9108 17.643 21.9628 16.5465C22.0186 15.36 22.0302 15.0037 22.0302 12C22.0302 8.99625 22.0186 8.64 21.9628 7.4535C21.9108 6.357 21.7217 5.7615 21.5621 5.36475C21.3521 4.83975 21.1002 4.46475 20.6934 4.071C20.2864 3.678 19.8989 3.4335 19.3564 3.23025C18.9464 3.075 18.3311 2.89275 17.198 2.8425ZM11.0156 15.468C11.4862 15.6567 11.9906 15.7538 12.5 15.7538C13.5288 15.7538 14.5154 15.3583 15.2428 14.6543C15.9702 13.9503 16.3789 12.9956 16.3789 12C16.3789 11.0045 15.9702 10.0497 15.2428 9.34571C14.5154 8.64174 13.5288 8.24626 12.5 8.24626C11.9906 8.24626 11.4862 8.34335 11.0156 8.532C10.545 8.72064 10.1174 8.99714 9.7572 9.34571C9.39709 9.69428 9.11133 10.1081 8.91638 10.5635C8.72144 11.0189 8.62109 11.5071 8.62109 12C8.62109 12.493 8.72144 12.9811 8.91638 13.4365C9.11133 13.8919 9.39709 14.3057 9.7572 14.6543C10.1174 15.0029 10.545 15.2794 11.0156 15.468ZM8.2749 7.91117C9.39551 6.82674 10.9153 6.21751 12.5 6.21751C14.0847 6.21751 15.6046 6.82674 16.7252 7.91117C17.8457 8.99559 18.4752 10.4664 18.4752 12C18.4752 13.5336 17.8457 15.0044 16.7252 16.0889C15.6046 17.1733 14.0847 17.7825 12.5 17.7825C10.9153 17.7825 9.39551 17.1733 8.2749 16.0889C7.1543 15.0044 6.52478 13.5336 6.52478 12C6.52478 10.4664 7.1543 8.99559 8.2749 7.91117ZM19.7999 7.07904C20.0648 6.8227 20.2136 6.47503 20.2136 6.11251C20.2136 5.74999 20.0648 5.40232 19.7999 5.14598C19.535 4.88964 19.1758 4.74564 18.8011 4.74564C18.4265 4.74564 18.0673 4.88964 17.8024 5.14598C17.5376 5.40232 17.3887 5.74999 17.3887 6.11251C17.3887 6.47503 17.5376 6.8227 17.8024 7.07904C18.0673 7.33538 18.4265 7.47939 18.8011 7.47939C19.1758 7.47939 19.535 7.33538 19.7999 7.07904Z" 
                            :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                        </svg>
                    </a>
                </li>

                <li class="header__socials-item">
                    <a href="https://api.whatsapp.com/message/KKFG6GDZ4FN3E1?autoload=1&app_absent=0" target="_blank" class="header__link">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C8.23277 20.003 6.4966 19.5353 4.97002 18.645L0.00401546 20L1.35602 15.032C0.464974 13.5049 -0.00308163 11.768 1.52687e-05 10C1.52687e-05 4.477 4.47702 0 10 0ZM6.59202 5.3L6.39201 5.308C6.26271 5.31691 6.13636 5.35087 6.02002 5.408C5.91159 5.46951 5.81258 5.5463 5.72602 5.636C5.60602 5.749 5.53802 5.847 5.46502 5.942C5.09514 6.4229 4.89599 7.01331 4.89902 7.62C4.90102 8.11 5.02902 8.587 5.22902 9.033C5.63802 9.935 6.31102 10.89 7.19902 11.775C7.41302 11.988 7.62302 12.202 7.84902 12.401C8.95245 13.3724 10.2673 14.073 11.689 14.447L12.257 14.534C12.442 14.544 12.627 14.53 12.813 14.521C13.1042 14.5056 13.3885 14.4268 13.646 14.29C13.7769 14.2223 13.9047 14.1489 14.029 14.07C14.029 14.07 14.0714 14.0413 14.154 13.98C14.289 13.88 14.372 13.809 14.484 13.692C14.568 13.6053 14.638 13.5047 14.694 13.39C14.772 13.227 14.85 12.916 14.882 12.657C14.906 12.459 14.899 12.351 14.896 12.284C14.892 12.177 14.803 12.066 14.706 12.019L14.124 11.758C14.124 11.758 13.254 11.379 12.722 11.137C12.6663 11.1128 12.6067 11.0989 12.546 11.096C12.4776 11.0888 12.4084 11.0965 12.3432 11.1184C12.278 11.1403 12.2182 11.176 12.168 11.223C12.163 11.221 12.096 11.278 11.373 12.154C11.3315 12.2098 11.2744 12.2519 11.2088 12.2751C11.1433 12.2982 11.0723 12.3013 11.005 12.284C10.9398 12.2666 10.876 12.2446 10.814 12.218C10.69 12.166 10.647 12.146 10.562 12.11C9.98789 11.8599 9.45646 11.5215 8.98702 11.107C8.86102 10.997 8.74402 10.877 8.62402 10.761C8.23063 10.3842 7.88777 9.95799 7.60401 9.493L7.54501 9.398C7.50328 9.3338 7.46905 9.26501 7.44302 9.193C7.40502 9.046 7.50402 8.928 7.50402 8.928C7.50402 8.928 7.74702 8.662 7.86002 8.518C7.97002 8.378 8.06301 8.242 8.12302 8.145C8.24102 7.955 8.27802 7.76 8.21602 7.609C7.93602 6.925 7.64668 6.24467 7.34802 5.568C7.28902 5.434 7.11402 5.338 6.95502 5.319C6.90102 5.31233 6.84701 5.307 6.79302 5.303C6.65874 5.2953 6.52411 5.29664 6.39002 5.307L6.59202 5.3Z"
                            :fill="scrollHeight < 5 ? '#060A2D' : '#fff'"/>
                        </svg>
                    </a>
                </li>

                <li class="header__socials-item">
                    <ForumSelectLang :scrollHeight="scrollHeight"/>
                </li>
            </ul>
            <div v-if="deviceWidth <= 1280" class="header__inner">
                <ForumSelectLang :scrollHeight="scrollHeight"/>
                <div class="header__burger" @click="active_menu = true">
                    <span class="header__burger-line" :class="{'line-move' : scrollHeight > 5}"></span>
                    <span class="header__burger-line" :class="{'line-move' : scrollHeight > 5}"></span>
                    <span class="header__burger-line" :class="{'line-move' : scrollHeight > 5}"></span>
                </div>
            </div>
        </div>
        <ForumMenu v-if="deviceWidth <= 1280" :active="active_menu" @closeMenu="closeMenu()"/>
    </header>
</template>

<script scoped>
    import ForumSelectLang from '@/components/ForumSelectLang.vue';
    import ForumMenu from '../ForumMenu.vue';
    export default {
        components: {
            ForumSelectLang,
            ForumMenu,
        },
        data() {
            return {
                active_menu: null,
                deviceWidth: 0,
                scrollHeight: 0,
            }
        },
        methods: {
            /*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
            resizeHandler() {
                this.deviceWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            },
            closeMenu(value) {
                this.active_menu = value;
            },
            anchor(event, blockID) {
                const targetElement = document.getElementById(blockID);

                if (targetElement) {
                    // Используем setTimeout, чтобы дождаться стандартной прокрутки браузера
                    setTimeout(() => {
                        const elementPosition = targetElement.getBoundingClientRect().top;
                        const offset = -100; // Смещение в пикселях

                        // Скроллим дополнительно с учетом смещения
                        window.scrollBy({
                            top: elementPosition + offset,
                            behavior: 'smooth',
                        });
                    }, 0);
                }
            },
            handleScroll() {
                // Обновляем значение scrollHeight при прокрутке
                this.scrollHeight = window.pageYOffset || document.documentElement.scrollTop;
            },
        },
        mounted() {
            window.addEventListener('resize', this.resizeHandler);
            
            this.resizeHandler();

            // Добавляем слушателя события прокрутки
            window.addEventListener('scroll', this.handleScroll);
        },

        unmounted() {
            window.removeEventListener('resize', this.resizeHandler);
            
            // Удаляем слушателя события прокрутки при уничтожении компонента
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>

<style lang="scss" scoped>

.descr-move {
    font-weight: 400;
    color: #fff;
}
.header {
    transition: 300ms ease-in-out;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 2;
    &__move {
        background-color: #060A2D;
    }
    &__container {
        transition: 300ms ease-in-out;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        min-height: 110px;
        font-weight: 600;
    }
    .container-move {
        min-height: 90px;
    }
    &__inner {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    &__line {
        display: block;
        background-color: #ABB0CE;
        height: 30px;
        width: 0.1px;
        @media screen and (max-width: 1280px) {
            display: none;
        }
    }
    &__icon {
        display: flex;
        gap: 61.1px;
    }
    &__menu {
        max-width: 800px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        @media screen and (max-width: 1280px) {
            display: none;
        }
    }
    &__item {
        cursor: pointer;
    }
    &__link {

    }
    &__socials {
        display: flex;
        align-items: center;
        gap: 35px;
        width: 310px;
        @media screen and (max-width: 1280px) {
            display: none;
        }
    }
    &__social-item {
        gap: 35px;
    }
    &__burger {
        width: 27px;
        height: 24px;
        display: none;    
        @media screen and (max-width: 1280px) {
            display: block;
        }
    }
    &__burger-line {
        display: block;
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background-color: #060A2D;
        margin-bottom: 6px;
    }
    .line-move {
        background-color: #fff;
    }
}
</style>
